import { useLazyQuery, useQuery } from "@apollo/client";
import { SHOP_CATGORIES } from "../shops.queries";
import {
  ShopCategoriesQuery,
  ShopCategoriesQueryVariables,
} from "../../../__generated__/ShopCategoriesQuery";

export const useShopCategories = () => {
  return useQuery<ShopCategoriesQuery, ShopCategoriesQueryVariables>(
    SHOP_CATGORIES,
    {
      variables: {
        where: {},
      },
      fetchPolicy: "network-only",
    }
  );
};

export const useLazyShopCategories = () => {
  return useLazyQuery<ShopCategoriesQuery, ShopCategoriesQueryVariables>(
    SHOP_CATGORIES
  );
};
